var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-logout';
                    var viewUrl = 'sprite.svg#view-icon-logout';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 14 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };